var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleLocations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-eea920a5-10eb-41f3-9efd-37a3f372672b",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.49,
    height: 14,
    viewBox: "0 0 14.49 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-76ad5963-cf74-46e6-aa84-28157a0fc9f0",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.3,7.44s-.1-.02-.14-.06L7.25.46.33,7.38c-.07.07-.2.07-.27,0-.07-.07-.07-.2,0-.27L7.11.05c.07-.07.2-.07.27,0l7.05,7.05c.07.07.07.2,0,.27-.04.04-.09.06-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41,14h-3.4c-.11,0-.19-.09-.19-.19v-4.88h-3.13v4.88c0,.11-.09.19-.19.19h-3.4c-.11,0-.19-.09-.19-.19V5.51c0-.11.09-.19.19-.19s.19.09.19.19v8.1h3.02v-4.88c0-.11.09-.19.19-.19h3.51c.11,0,.19.09.19.19v4.88h3.02V5.51c0-.11.09-.19.19-.19s.19.09.19.19v8.29c0,.11-.09.19-.19.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleLocations);
export default __webpack_public_path__ + "static/media/icon_module_locations.ca11106d5ab6d2406a1c686abdf8b20b.svg";
export { ForwardRef as ReactComponent };